import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { 
  AlignJustify as Menu, 
  X, 
  Home, 
  Bot, 
  Phone, 
  Settings, 
  PhoneCall, 
  Users, 
  User,
  Shield,
  LogOut
} from 'lucide-react'
import { useAuth } from '../contexts/AuthContext'
import Sidebar from './Sidebar'
import Header from './Header'

function Layout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const { user, logout } = useAuth()
  const location = useLocation()

  const navigation = [
    { name: 'Dashboard', href: '/dashboard', icon: Home },
    { name: 'Agents', href: '/agents', icon: Bot },
    //{ name: 'Apps', href: '/apps', icon: Settings },
    { name: 'Calls', href: '/calls', icon: PhoneCall },
    { name: 'Tickets', href: '/tickets', icon: Users },
    { name: 'Outbound', href: '/outbound', icon: Phone },
    ...(user?.role === 'admin' ? [
      { name: 'Users', href: '/users', icon: Users },
      { name: 'Admin', href: '/admin', icon: Shield },
    ] : []),
  ]

  const userNavigation = [
    { name: 'Profile', href: '/profile', icon: User },
    { name: 'Sign Out', action: logout, icon: LogOut },
  ]

  return (
    <div className="min-h-screen bg-primary-50">
      <Sidebar
        navigation={navigation}
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        currentPath={location.pathname}
      />

      <div className="lg:pl-72">
        <Header
          user={user}
          userNavigation={userNavigation}
          setSidebarOpen={setSidebarOpen}
        />

        <main className="py-6">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            {children}
          </div>
        </main>
      </div>
    </div>
  )
}

export default Layout
